<template>
  <v-dialog
    transition="dialog-top-transition"
    max-width="600"
    persistent
    v-model="unauthorized"
  >
    <template v-slot:default>
      <v-card>
        <v-card-text class="pa-8">
          <h2>401 Unauthorized</h2>
          <div class="mt-4">
            Uh oh...
            <span v-if="isUserSignedIn"
              >looks like you don't have authorization for the requested
              resource. If this continues contact support to verify you have the
              required privileges.</span
            >
            <span v-else
              >looks your session expired. Please
              <router-link to="/logout">logout</router-link> and log back
              in.</span
            >
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            v-if="isUserSignedIn"
            @click="close"
            color="primary"
            class="black--text"
            >Close</v-btn
          >
          <v-btn v-else to="/logout" class="black--text" color="primary"
            >Logout</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import auth from "@/app/auth";
import store from "@/store";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const { useState } = createNamespacedHelpers("ui");

export default {
  name: "Unauthorized",
  mounted() {
    this.$log.debug();
  },
  setup() {
    const { unauthorized } = useState(["unauthorized"]);
    return {
      unauthorized,
    };
  },
  computed: {
    isUserSignedIn() {
      return auth && auth.auth && auth.auth.isUserSignedIn();
    },
  },
  methods: {
    close() {
      store.commit("ui/HIDE_UNAUTHORIZED");
    },
  },
};
</script>
